import { red } from '@ant-design/colors'
import styled from 'styled-components'
import TableWrapper from '../../../../components/table-wrapper/table-wrapper'

const RewindQueueTableWrapper = styled(TableWrapper)`
    .rewind-job-cancelled td {
        background-color: ${red[1]};
    }

    .rewind-job-paused td {
        background-color: #fffbe6;
    }

    .rewind-print-waiting td {
        color: ${({ theme }) => theme.colorTextTertiary};
    }
`

export default RewindQueueTableWrapper
